<form [formGroup]="assigneeForm()">
  <div class="flex flex-col gap-lg">
    <div
      class="grid [grid-template-columns:repeat(auto-fill,minmax(20rem,1fr))] gap-lg">
      <div>
        <lib-paginated-select
          [inputFormControlName]="'reason_option_id'"
          [id]="'reason_option_id'"
          [name]="'reason_option_id'"
          [label]="'request_screen_reason_label' | transloco"
          [placeholder]="'request_screen_select_reason_placeholder' | transloco"
          [apiUrl]="
            baseUrl +
            '/lookup/variable-options?filters[variable][module]=workflow&filters[variable][key]=action_reason&filters[is_active]=1'
          "
          [required]="true"
          [filters]="[]"
          [detailsNotFoundLabel]="'details_not_found_label' | transloco"
          [noDataLabel]="'user_dropdown_input_no_data_label' | transloco"
          (changeOption)="checkFormValidity()" />

        <lib-validation-message
          [lang]="'current_lang' | transloco"
          control="reason_option_id" />
      </div>

      <!-- Resource Type Field -->
      <div>
        <lib-select
          [inputFormControlName]="'assignable_type'"
          [id]="'assignable_type'"
          [name]="'assignable_type'"
          [required]="true"
          [label]="'request_screen_resource_type_label' | transloco"
          [options]="assigneeTypeOptions"
          [selectedKeyName]="'label'"
          [selectedKeyValue]="'value'"
          [placeholder]="'request_screen_select_type_placeholder' | transloco"
          [selectedOption]="selectedAssignableTypeOption() || undefined"
          (changeOption)="onAssignableTypeChange($event)" />

        <lib-validation-message
          [lang]="'current_lang' | transloco"
          control="assignable_type" />
      </div>

      <!-- Resource Option Field (for group/department only) -->
      @if (
        assigneeForm().get('assignable_type')?.value === 'group' ||
        assigneeForm().get('assignable_type')?.value === 'department'
      ) {
        <div>
          <lib-select
            [inputFormControlName]="'option'"
            [id]="'option'"
            [name]="'option'"
            [required]="true"
            [label]="'request_screen_resource_option_label' | transloco"
            [options]="
              assigneeForm().get('assignable_type')?.value === 'group'
                ? groupAssignableOptions
                : departmentAssignableOptions
            "
            [selectedKeyName]="'label'"
            [selectedKeyValue]="'value'"
            [placeholder]="
              'request_screen_resource_option_placeholder' | transloco
            "
            [disabled]="!assigneeForm().get('assignable_type')?.value"
            [selectedOption]="selectedAssignableOption() || undefined"
            (changeOption)="selectAssignableOption($event)" />

          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="option" />
        </div>
      }

      <!-- Resource Selection Field -->
      <div>
        @if (assigneeForm().get('assignable_type')?.value !== 'legal_entity') {
          <lib-customized-dropdown
            [id]="'assignable_id'"
            [inputFormControlName]="'assignable_id'"
            [name]="'assignable_id'"
            [required]="true"
            [label]="getAssignableTypeLabel()"
            [placeholder]="assigneeSelectDependency().placeholder"
            [apiUrl]="assigneeSelectDependency().api"
            [selectedOption]="assigneeSelectDependency().selectedOption"
            [filters]="assigneeSelectDependency().filters"
            [searchLabel]="assigneeSelectDependency().searchLabel"
            [searchPlaceholder]="assigneeSelectDependency().searchPlaceholder"
            [noDataLabel]="'request_screen_no_data_label' | transloco"
            [disabled]="!assigneeForm().get('assignable_type')?.value"
            (changeOption)="selectResource($event)" />
        } @else {
          <lib-paginated-select
            [id]="'assignable_id'"
            [inputFormControlName]="'assignable_id'"
            [name]="'assignable_id'"
            [required]="true"
            [label]="getAssignableTypeLabel()"
            [placeholder]="assigneeSelectDependency().placeholder"
            [apiUrl]="assigneeSelectDependency().api"
            [selectedOption]="assigneeSelectDependency().selectedOption"
            [disabled]="!assigneeForm().get('assignable_type')?.value"
            (changeOption)="selectResource($event)" />
        }

        <lib-validation-message
          [lang]="'current_lang' | transloco"
          control="assignable_id" />
      </div>

      <!-- Assignment Preferences (for group/department and legal_entity) -->
      @if (
        (assigneeForm().get('assignable_type')?.value === 'group' ||
          assigneeForm().get('assignable_type')?.value === 'department') &&
        assigneeForm().get('option')?.value !== 'manager'
      ) {
        <div>
          <lib-select
            [inputFormControlName]="'preference_option'"
            [id]="'preference_option'"
            [name]="'preference_option'"
            [required]="true"
            [label]="'request_screen_assignees_preference_label' | transloco"
            [options]="assignmentPreferenceOptions"
            [selectedKeyName]="'label'"
            [selectedKeyValue]="'value'"
            [placeholder]="
              'request_screen_select_assignees_preference_placeholder'
                | transloco
            "
            [disabled]="
              !assigneeForm().get('assignable_type')?.value ||
              !assigneeForm().get('option')?.value
            "
            [selectedOption]="selectedAssignmentPreferenceOption() || undefined"
            (changeOption)="selectAssignmentPreference($event)" />

          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="preference_option" />
        </div>
      }

      @if (assigneeForm().get('assignable_type')?.value === 'legal_entity') {
        <div>
          <lib-select
            [inputFormControlName]="'preference_option'"
            [id]="'preference_option'"
            [name]="'preference_option'"
            [required]="true"
            [label]="'request_screen_assignees_preference_label' | transloco"
            [options]="assignmentPreferenceOptions"
            [selectedKeyName]="'label'"
            [selectedKeyValue]="'value'"
            [placeholder]="
              'request_screen_select_assignees_preference_placeholder'
                | transloco
            "
            [disabled]="!assigneeForm().get('assignable_type')?.value"
            [selectedOption]="selectedAssignmentPreferenceOption() || undefined"
            (changeOption)="selectAssignmentPreference($event)" />

          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="preference_option" />
        </div>
      }

      <!-- Number of Assignees (when "at least" is selected) -->
      @if (assigneeForm().get('preference_option')?.value === 'at_least') {
        <div>
          <lib-input
            [inputFormControlName]="'preference'"
            [id]="'preference'"
            [name]="'preference'"
            [type]="'number'"
            [required]="true"
            [label]="'request_screen_number_of_assignees_label' | transloco"
            [placeholder]="
              'request_screen_number_of_assignees_placeholder' | transloco
            "
            (inputChange)="checkFormValidity()" />

          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="preference" />
        </div>
      }
    </div>

    <div class="gap-lg w-full">
      <div>
        <lib-rich-editor-dual-lang-text-area
          [inputFormControlName]="'comment'"
          [id]="'comment'"
          [name]="'comment'"
          [label]="'request_screen_reassign_comment_label' | transloco"
          [placeholderEn]="
            'request_screen_reassign_comment_placeholder' | transloco
          "
          [placeholderAr]="
            'request_screen_reassign_comment_placeholder' | transloco
          "
          [width]="'100%'"
          [requiredEn]="true"
          [requiredAr]="false"
          [disabled]="false"
          [canResize]="false"
          [isSingleInput]="true" />
      </div>
    </div>

    <div class="flex justify-end gap-md mt-lg">
      <button
        type="button"
        (click)="onClose()"
        class="px-lg py-sm rounded-md text-neutral-600 bg-white border border-neutral-300 text-sm font-medium cursor-pointer">
        {{ 'request_screen_cancel_button' | transloco }}
      </button>
      <button
        type="button"
        (click)="onSubmit()"
        [class.opacity-30]="!isFormValid()"
        [disabled]="!isFormValid()"
        class="px-lg py-sm rounded-md text-white bg-primary-500 text-sm font-medium border-none cursor-pointer">
        {{ 'request_screen_submit_button' | transloco }}
      </button>
    </div>
  </div>
</form>
